const app = require.context('.', true, /\.js$/)
app.keys().forEach(app)
